/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S1_P1Inputs */

const tr_iade_iptal_s1_p1 = /** @type {(inputs: Iade_Iptal_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Politika, ShopPanel SaaS abonelik hizmetlerinin Abone tarafından iptal edilmesi, taraflarca feshedilmesi, geri ödeme yapılması ve hesabın kapatılması süreçlerini düzenler.`)
};

const en_iade_iptal_s1_p1 = /** @type {(inputs: Iade_Iptal_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Policy governs the cancellation of the ShopPanel SaaS subscription services by the Subscriber, their termination by the parties, refunds and the closure of the account.`)
};

const de_iade_iptal_s1_p1 = /** @type {(inputs: Iade_Iptal_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Richtlinie regelt die Kündigung der ShopPanel SaaS Abonnementdienste durch den Abonnenten, die Beendigung durch die Parteien, die Rückerstattung und die Schließung des Kontos.`)
};

const ru_iade_iptal_s1_p1 = /** @type {(inputs: Iade_Iptal_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящая Политика регулирует порядок отмены абонентом услуг подписки ShopPanel SaaS, расторжения сторонами, возврата средств и закрытия учётной записи.`)
};

/**
* | output |
* | --- |
* | "This Policy governs the cancellation of the ShopPanel SaaS subscription services by the Subscriber, their termination by the parties, refunds and the closure..." |
*
* @param {Iade_Iptal_S1_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s1_p1 = /** @type {((inputs?: Iade_Iptal_S1_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S1_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s1_p1(inputs)
	if (locale === "de") return de_iade_iptal_s1_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s1_p1(inputs)
	return tr_iade_iptal_s1_p1(inputs)
});